import { ReactNode } from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { CircularProgress } from '@vk-hr-tek/ui/CircularProgress';

interface PageLoadingProps {
  loadingComponent?: ReactNode;
}

export const PageLoading = ({
  loadingComponent = <CircularProgress size={50} />,
}: PageLoadingProps) => (
  <Box display="flex" justifyContent="center" pt="40">
    {loadingComponent}
  </Box>
);
